<div class="d-flex g-0">
  <app-blast-history
    [class]="isBlastHistoryCollapsed() ? 'col-md-1' : 'col-md-5'"
    [tirId]="tirId()"
    (collapseChanged)="onBlastHistoryCollapseChanged($event)"
  >
  </app-blast-history>
  <app-document-storage
    [class]="isBlastHistoryCollapsed() ? 'col-md-11 pl-0' : 'col-md-7'"
    [tirId]="tirId()"
    [racine]="racine()"
    [apiEndPoint]="apiEndPoint()"
    (securityIsChange)="onSecurityChange($event)"
  >
  </app-document-storage>
</div>